import React from "react";
import SupportTicketDetailPage from "../dashboard/SupportTicketDetailPage";

export default function SuperAdminTicketDetailPage({
  backPath = "/super-admin/tickets",
}) {
  return (
    <SupportTicketDetailPage
      mode="super-admin"
      backPath={backPath}
      backLabel="Ticket Management"
    />
  );
}
